import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import SimpleReactValidator from 'simple-react-validator';
import { getPhysicalRestrictionListDetails, createPhysicalRestriction, editPhysicalRestriction } from "../../redux/actions/master"


class PhysicalRestrictionModalClass extends Component {

	state = {
		physicalRestrictionDetails: {
			restriction_name: '',

		},
		isEdit: false
	}

	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}

	componentWillReceiveProps(props) {

		let { modalDetails, isEdit } = props

		this.setState({
			physicalRestrictionDetails: modalDetails,
			isEdit: isEdit,
		})
	}

	handleInputs = ({ target: { value, name } }) => {

		let physicalRestrictionDetails = Object.assign({}, this.state.physicalRestrictionDetails)

		physicalRestrictionDetails[name] = value

		this.setState({
			physicalRestrictionDetails
		})


	}

	handleSubmit = () => {

		if (this.validator.allValid()) {

			let { physicalRestrictionDetails: { restriction_name, id }, isEdit } = this.state

			let body = {
				restriction_name: restriction_name
			}

			if (!isEdit) {

				this.props.createPhysicalRestriction(body).then(() => {

					this.props.getPhysicalRestrictionListDetails().then(() => {
						let temp = {
							restriction_name: '',
						}

						this.setState({
							isEdit: false,
							physicalRestrictionDetails: temp

						})
					})
				})
			} else {

				this.props.editPhysicalRestriction(id, body).then((message) => {

					this.props.getPhysicalRestrictionListDetails().then(() => {
						let temp = {
							restriction_name: '',
						}

						this.setState({
							isEdit: false,
							physicalRestrictionDetails: temp

						})
					})

				})
			}


			this.props.toggle()

			this.validator.hideMessages();

		} else {
			this.setState({
				isError: true
			})
			this.validator.showMessages();

		}
	}


	render() {

		let { isError, isEdit, toggle } = this.props

		let { physicalRestrictionDetails } = this.state

		this.validator.purgeFields();

		let { restriction_name } = physicalRestrictionDetails

		return (
			<section className="side-slider h-100">
				<div className="slider-header p-4">
					<div className="d-flex align-items-center">
						<h5 className="sair-sec-title"> {isEdit ? "Edit Physical Restriction" : "Add Physical Restriction"}</h5>
						<div className="ml-auto">
							<i className="icon-close font-md px-2 cursor-pointer"
								onClick={toggle}
							></i>
						</div>
					</div>
				</div>
				<div className="slider-body p-4">
					<div className={`row no-gutters ${isError ? "was-validated" : ""}`}>
						<div className="col-md-12 form-group">
							<label>Physical Restriction name</label>
							<textarea
								className={`form-control ${this.validator.message('name', restriction_name, 'required') ? 'inValid' : ''}`} id="restriction_name"
								placeholder=""
								name="restriction_name"
								value={restriction_name}
								type="text"
								row="3"
								onChange={this.handleInputs}


							> </textarea>
							{this.validator.message('name', restriction_name, 'required')}
						</div>


					</div>

					<hr />
					<button
						className="btn btn-primary"

						onClick={() => this.handleSubmit()}

					>{isEdit ? "Update" : "Submit"}</button>
				</div>
			</section>
		)
	}
}


const mapStateToProps = state => {

	return {}

};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		getPhysicalRestrictionListDetails,
		createPhysicalRestriction,
		editPhysicalRestriction
	}, dispatch)
};

export const PhysicalRestrictionModal = connect(mapStateToProps, mapDispatchToProps)(PhysicalRestrictionModalClass)

